
import { io } from 'socket.io-client';
import React, { createContext, useContext } from 'react';

import { credentials } from '@shootsta/client-auth';










// $FlowFixMe
const SocketContext = createContext();

export function useSocketContext() {
  return useContext(SocketContext);
}

export function SocketProvider({
  children,
  url
}) {
  const { token } = credentials.get();

  const socket = io(url, {
    path: '/sockets',
    transports: ['websocket', 'polling'],
    autoConnect: false,
    auth: {
      token
    }
  });

  return (
    <SocketContext.Provider
      value={{
        socket
      }}>

      {children}
    </SocketContext.Provider>);

}